




















































































import BaseComponent from "@/components/base/BaseComponent";
import {BankAccountDetails} from "@/components/dashboard/process-management/model/BankAccountDetails";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {KeyValuePair} from "@payroll/optimus-common";
import {Component} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({})
export default class MemberBankDetails extends BaseComponent {

  @Action('getBanks', StoreNamespace.PROCESSES_MANAGEMENT) getBanks: any;
  @Action('getBankBranches', StoreNamespace.PROCESSES_MANAGEMENT) getBankBranches: any;

  @Action('checkIfBankAccountNumberValid', StoreNamespace.PROCESSES_MANAGEMENT) checkIfBankAccountNumberValid: any;

  private readonly FETCH_BANKS: string = 'getBanks';
  private readonly FETCH_BANK_BRANCHES: string = 'getBankBranches';
  private readonly CHECK_IF_BANK_ACCOUNT_NUMBER_VALID: string = 'checkIfBankAccountNumberValid';

  private banks: KeyValuePair[] = [];
  private bankBranches: KeyValuePair[] = [];
  private showBankAccountNotValidMessage: boolean = false;
  private showBankAccountValidMessage: boolean = false;
  private showSpinner: boolean = false

  private bankAccountDetails: BankAccountDetails = {
    bank: {description: '', value: ''},
    branch: {description: '', value: ''},
    accountNum: null,
  }


  mounted() {
    this.showSpinner = true
    this.getBanks({requestorCallback: this});
  }

  getMemberBank() {
    if (this.banks.length &&
        this.bankAccountDetails.bank &&
        this.bankAccountDetails.bank.value) {
      const bank: KeyValuePair = this.banks.find((bank) => bank.value === this.bankAccountDetails.bank.value) as KeyValuePair;
      return bank;
    }

    return {};
  }

  getMemberBranch() {
    if (this.bankBranches.length &&
        this.bankAccountDetails.branch &&
        this.bankAccountDetails.branch.value) {
      const branch: KeyValuePair = this.bankBranches.find((branch) => branch.value === this.bankAccountDetails.branch.value) as KeyValuePair;
      return branch;
    }

    return {};
  }

  onBankChange() {
    if (this.bankAccountDetails && this.bankAccountDetails.bank.value) {
      const bankCode = this.bankAccountDetails.bank.value;
      if (bankCode) {
        this.bankBranches = []
        this.getBankBranches({pathVariable: bankCode, requestorCallback: this});
      }
    }
  }

  checkBankAccountNumberValid() {
    this.showSpinner = true

    this.checkIfBankAccountNumberValid({
      requestorCallback: this,
      requestBody: {
        bankCode: this.bankAccountDetails.bank.value,
        branchCode: this.bankAccountDetails.branch.value,
        bankAccountNumber: this.bankAccountDetails.accountNum,
        calculationTypeCode: '',
        accountCheckCancel: ''
      }
    });

  }



  onSuccess(data?: any, requestName?: string, message?: string, success?: boolean): void {
    switch (requestName) {

      case this.FETCH_BANKS:
        this.showSpinner = false
        this.banks = data;
        break;

      case this.FETCH_BANK_BRANCHES:
        this.bankBranches = data;
        break;

      case this.CHECK_IF_BANK_ACCOUNT_NUMBER_VALID:
        this.showSpinner = false
        if (data.isValid) {
          this.showBankAccountNotValidMessage = false;
          this.showBankAccountValidMessage = true;
          this.$emit('updateBankDetails', this.bankAccountDetails)
        } else {
          this.showBankAccountValidMessage = false
          this.showBankAccountNotValidMessage = true;
        }

        break;
    }
  }

  onError(messages: string[], code: number, requestName?: string) {
    this.showSpinner = false
    switch (requestName) {
      case this.CHECK_IF_BANK_ACCOUNT_NUMBER_VALID:
        this.showBankAccountValidMessage = false
        this.showBankAccountNotValidMessage = true;
        break;
      default :
        super.onError(messages, code, requestName);
    }
  }
}
